var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  y: 0.977,
  fill: "#000",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#sd_svg__a)",
  d: "M9.873 10.124a.8.8 0 0 1-.189.221.4.4 0 0 1-.24.065.63.63 0 0 1-.312-.097 6 6 0 0 0-.384-.221 3.5 3.5 0 0 0-.507-.215 2 2 0 0 0-.67-.104q-.675 0-1.013.306a1 1 0 0 0-.338.786q0 .313.182.52.189.203.487.351.306.15.69.267t.786.26q.403.136.786.325.384.189.683.474.306.287.487.702.189.41.189 1.001 0 .644-.228 1.21a2.9 2.9 0 0 1-.643.98q-.422.417-1.047.657-.617.24-1.404.24-.448 0-.897-.09a5.3 5.3 0 0 1-.858-.254 5 5 0 0 1-.773-.39 3.4 3.4 0 0 1-.637-.507l.572-.923a.55.55 0 0 1 .188-.169.47.47 0 0 1 .247-.071q.175 0 .37.13t.45.286q.252.156.584.286.338.13.806.13.682 0 1.053-.312.378-.312.377-.93 0-.357-.188-.578A1.45 1.45 0 0 0 8 14.09q-.3-.15-.683-.254a26 26 0 0 1-.786-.24 6.4 6.4 0 0 1-.787-.313 2.32 2.32 0 0 1-1.17-1.222q-.182-.441-.182-1.098a2.6 2.6 0 0 1 .82-1.898q.402-.384.987-.618a3.7 3.7 0 0 1 1.352-.234q.852 0 1.573.267.729.26 1.229.728zM20.38 13.03q0 1.034-.352 1.904a4.3 4.3 0 0 1-.981 1.489q-.63.623-1.521.975a5.4 5.4 0 0 1-1.976.35h-3.627v-9.43h3.627q1.085 0 1.976.35.89.351 1.521.982.637.624.982 1.488.35.865.35 1.892m-2.003 0q0-.74-.195-1.333a2.8 2.8 0 0 0-.558-1 2.4 2.4 0 0 0-.891-.631 3 3 0 0 0-1.183-.221h-1.664v6.376h1.664q.663 0 1.183-.214.527-.221.89-.63.365-.417.56-1.008.194-.59.194-1.34"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sd_svg__a",
  x1: 3.776,
  x2: 21.439,
  y1: 12.115,
  y2: 12.245,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCF476"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAA140"
})))));
export default SvgSd;